import { render, staticRenderFns } from "./CounsellorEdit.vue?vue&type=template&id=38139d70&"
import script from "./CounsellorEdit.vue?vue&type=script&lang=js&"
export * from "./CounsellorEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports